export default "__VITE_ASSET__e3d15f85__"